import { enumUtil } from "../../../../utils/Enum";
import { ServerRequestProtected } from "../../../../utils/ServerDataRequest";


const API_URL = enumUtil.controller.Patient;
const API_GENERAL = enumUtil.controller.General;


export const getAvailableSlots = (providerId, locationId, appointmentDate) => {
    return ServerRequestProtected(
        API_GENERAL + "/AvailableSlots",
        "POST",
        {
            SEARCHCRITERIA: {
                ProviderID: String(providerId),
                LocationID: String(locationId),
                Date: appointmentDate
            },
            TABLENAME: enumUtil.enumAPITableName.Scheduler
        }
    );
};

export const findAppointmentById = (appointmentId) => {
    return ServerRequestProtected(
        API_URL + "/FindByID",
        "POST",
        {
            TableName: enumUtil.enumAPITableName.PatientAppointment,
            ID: appointmentId
        }
    );
};

export const findPatientInsuranceDetails = (patientId) => {
    return ServerRequestProtected(
        API_URL + "/FindPatientInsuranceDetails",
        "POST",
        {
            ID: String(patientId),
            TableName: enumUtil.enumAPITableName.PatientInsurance
        }
    );
};

export const getPatientInsurances = (patientId) => {
    return ServerRequestProtected(
        API_URL + "/FindPatientPay",
        "POST",
        {
            TABLENAME: enumUtil.enumAPITableName.CollectCopay,
            SEARCHCRITERIA: { PatientID: String(patientId) }
        }
    );
};

export const getProviderScheduler = (providerId, locationId, date) => {
    return ServerRequestProtected(
        API_GENERAL + "/ProvidersSchedules",
        "POST",
        {
            TableName: enumUtil.enumAPITableName.Scheduler,
            SearchCriteria: {
                providerID: String(providerId),
                locationID: String(locationId),
                Date: date
            }
        }
    );
};

export const getProceduresByAppointmentType = (appointmentTypeId) => {
    return ServerRequestProtected(
        API_GENERAL + "/FindByMultipleCriteria",
        "POST",
        {
            ID: String(appointmentTypeId),
            TableName: enumUtil.enumAPITableName.AppointmentTypeProcedureCode
        }
    );
};

export const getIntakeDropdown = () => {
    return ServerRequestProtected(
        API_GENERAL + "/DropDown",
        "POST",
        {
            TableName: "EhrTemplate"
        }
    );
};
export const appointmentService = {
    findAppointmentById,
    getAvailableSlots,
    getPatientInsurances,
    findPatientInsuranceDetails,
    getProviderScheduler,
    getProceduresByAppointmentType,
    getIntakeDropdown
};